const drawerSelectors = {
  cartIconDesktop: document.querySelector("#cart-icon-desktop"),
  cartIconMobile: document.querySelector("#cart-icon-mobile"),
  cartTotal: document.querySelector("cart-form [data-cart-total]"),
};

class AjaxCart extends HTMLElement {
  constructor() {
    super();
    this.cartForm = this.querySelector("form[data-cart-form]");
    this.promoForm = this.querySelector(".promo-form");
    this.cartDrawer = document.querySelector("#component-cart-drawer");
    this.sectionID = "component-cart-drawer";

    if (window.globalSpace.template == "cart") {
      this.sectionID = document.getElementById("cart--items").dataset.id;
      this.updateEvents();
    } else {
      this.getCartData();
    }

    // Setup continue shopping link
    if (window.globalSpace.cart.item_count <= 0) {
      this.setupContinueShoppingLink();
    }

    // Setup promo banner click events on initial load
    this.promoBannerClick();

    this.cartForm.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.keyCode === 13) {
        e.preventDefault();
      }
    });
    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    // Refresh cart on browser back/forward navigation
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.getCartData();
      }
    });
  }

  /**
   * Observe attribute of component
   *
   * @returns {array} Attributes to Observe
   */
  static get observedAttributes() {
    return ["updating"];
  }

  /**
   * bind Other inside element events to DOM
   */
  updateEvents() {
    this.cartForm
      .querySelectorAll("[data-item-remove]")
      .forEach((button) =>
        button.addEventListener("click", this.removeItem.bind(this))
      );
    this.cartForm
      .querySelectorAll("[data-qty-btn]")
      .forEach((button) =>
        button.addEventListener("click", this.manageQtyBtn.bind(this))
      );
    this.cartForm.querySelectorAll("[data-qty-input]").forEach((input) => {
      let previousValue = input.value;
      const handleQtyChange = (e) => {
        const currentValue = input.value;
        const keyIsEnter =
          e.type === "keyup" && (e.key === "Enter" || e.keyCode === 13);
        const isBlurOrChange = e.type === "blur" || e.type === "change";
        if ((keyIsEnter || isBlurOrChange) && currentValue !== previousValue) {
          previousValue = currentValue;
          this.onQtyChange(e);
        }
      };
      ["blur", "change", "keyup"].forEach((eventType) => {
        input.addEventListener(eventType, handleQtyChange);
      });
    });
  }

  /**
   * Setup continue shopping link event listener
   */
  setupContinueShoppingLink() {
    const continueShoppingLink =
      this.cartForm.querySelector("#continue-shopping-link") ||
      this.querySelector("#continue-shopping-link") ||
      document.querySelector("#continue-shopping-link");
    if (continueShoppingLink) {
      continueShoppingLink.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let brand =
          document.body.getAttribute("data-brand") ||
          "Chalk Talk" ||
          "ChalkTalk";
        let redirectUrl = "/";
        if (brand === "Gone For A Run" || brand === "Gone for a Run") {
          redirectUrl = "/pages/gfar-home-page";
        } else if (brand === "Lulalax" || brand === "lulalax") {
          redirectUrl = "/pages/girls-lacrosse";
        }
        window.location.href = redirectUrl;
      });
    }
  }

  /**
   * Setup promo banner click events
   */
  promoBannerClick() {
    const promoBanners = document.querySelector(".promo-banner-clickable");
    if (promoBanners) {
      promoBanners.addEventListener("click", (e) => {
        if (
          e.target.closest(
            "button, [data-product-upsell-btn], form, input, select, textarea"
          )
        ) {
          return;
        }
        const productColumn = promoBanners.querySelector("[data-product-id]");
        if (!productColumn) return;
        const productId = productColumn.getAttribute("data-product-id");
        const upsellButton = promoBanners.querySelector(
          `[data-product-upsell-btn][data-product-id="${productId}"]`
        );
        if (upsellButton) {
          upsellButton.click();
        }
      });
      promoBanners.style.cursor = "pointer";
    }
  }

  /**
   * Open Cart drawer and add focus to drawer container
   */
  initCartDrawer(elementTofocus) {
    if (!window.globalSpace.cart_drawer) {
      window.location.href = window.routes.cart_fetch_url || "/cart";
      return;
    }

    if (this.cartDrawer) this.cartDrawer.openDrawer(elementTofocus);
  }

  /**
   * Fetch latest cart data
   */
  getCartData() {
    const cartRoute = `${window.location.pathname}?sections=${this.sectionID},header`;
    fetch(cartRoute)
      .then((response) => response.json())
      .then((response) => {
        this._updateCart(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Cart HTML fetch done
      });
  }

  /**
   * Update cart HTML and Trigger Open Drawer event
   *
   * @param {string} cartHTML String formatted response from fetch cart.js call
   * @param {HTML Node} openDrawerBtn open drawer node
   */
  _updateCart(response, openDrawerBtn = null) {
    if (response === null || response == undefined) return;
    
    this.setAttribute("updating", true);
    let cartHTML = response[this.sectionID] || response["template-cart"];
    const parser = new DOMParser();
    cartHTML = parser.parseFromString(cartHTML, "text/html");

    const cartJSONEle = cartHTML.querySelector("[data-cartScriptJSON]");
    window.globalSpace.cart = JSON.parse(cartJSONEle.textContent);

    const cartElement = cartHTML.querySelector("#cart-form");
    this.cartForm.innerHTML = cartElement.innerHTML;

    const bundleElement = cartHTML.querySelector(".promo-form");
    if (bundleElement) {
      this.promoForm.innerHTML = bundleElement.innerHTML;
    }

    const cartTotal = Utility.formatMoney(
      window.globalSpace.cart.total_price,
      window.globalSpace.money_format
    );
    const cartOriginalTotal = Utility.formatMoney(
      window.globalSpace.cart.original_total_price,
      window.globalSpace.money_format
    );

    if (document.querySelector("[data-original]")) {
      if (
        window.globalSpace.cart.original_total_price >
        window.globalSpace.cart.total_price
      ) {
        document.querySelector("[data-original]").innerHTML = cartOriginalTotal;
        document.querySelector("[data-original]").classList.remove("d-none");
      } else {
        document.querySelector("[data-original]").classList.add("d-none");
      }
    }
    drawerSelectors.cartTotal.innerHTML = cartTotal;

    const cartItemsCount = cartHTML.querySelector("[data-item-count]");
    if (cartItemsCount)
      this.querySelector("[data-item-count]").innerHTML =
        cartItemsCount.innerHTML;

    const cartFormContainer = this.querySelector(".cart-form-container");
    window.globalSpace.cart.item_count <= 0
      ? cartFormContainer.classList.add("empty_cart")
      : cartFormContainer.classList.remove("empty_cart");

    const headerHTML = new DOMParser().parseFromString(
      response.header,
      "text/html"
    );
    const cartIcon = headerHTML.getElementById("cart-icon-desktop");
    if (drawerSelectors.cartIconDesktop)
      drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
    if (drawerSelectors.cartIconMobile)
      drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

    this.updateEvents();
    if (window.globalSpace.cart.item_count <= 0) {
      this.setupContinueShoppingLink();
    }

    // Re-attach promo banner click events after cart update
    this.promoBannerClick();

    Shopify.PaymentButton.init();
    if (window.globalSpace.cart_drawer && openDrawerBtn) {
      this.initCartDrawer(openDrawerBtn);
    }
    if (
      document
        .querySelector("quick-shop .quickshop-drawer")
        ?.classList.contains("open")
    ) {
      document.querySelector(".quickshop-drawer").classList.remove("open");
      document.querySelector("quick-shop").innerHTML = "";
      SiteOverlay.prototype.hideOverlay();
    }
  }
  async updateProperties(items) {
    const variantIds = items.split(":").map((id) => id.trim());

    const cart = await fetch("/cart.js").then((r) => r.json());
    let propertiesToRemove = [
      "_bundle_unique_id",
      "_bundle_parent_id",
      "_bundle_pricing",
    ];
    const sections = `${this.sectionID},header`;
    const matchedItems = cart.items.filter((item) =>
      variantIds.includes(item.variant_id.toString())
    );

    if (!matchedItems.length) return;

    const bundleGroups = {};
    matchedItems.forEach((item) => {
      const bundleId = item.properties?._bundle_unique_id;
      if (!bundleId) return;

      if (!bundleGroups[bundleId]) bundleGroups[bundleId] = [];
      bundleGroups[bundleId].push(item);
    });

    if (Object.keys(bundleGroups).length > 1) {
      console.warn("Multiple bundles detected — not modifying anything.");
      return;
    }
    const targetBundleId = Object.keys(bundleGroups)[0];
    const itemsToUpdate = bundleGroups[targetBundleId];
    for (const item of itemsToUpdate) {
      const newProps = { ...item.properties };
      propertiesToRemove.forEach((prop) => {
        delete newProps[prop];
      });

      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.key,
          properties: newProps,
          sections,
        }),
      });
    }

    console.log("✅ Properties removed from matched bundle items.");
  }

  async updateItemQty(line, quantity, event) {
  const lineItem = document.querySelectorAll("[data-cart-item]")[line - 1];
  // if (!lineItem) return;
    let cartSectionID = "component-cart-drawer";
  if (window.globalSpace?.template === "cart") {
    cartSectionID =
      document.getElementById("cart--items")?.dataset.id ||
      "template-cart";
  }
if(event){
  
if (lineItem.getAttribute("_unique_custom_id") !== null) {
if (event.target.closest(".input-group-text")?.classList.contains("will-remove-item") || event.target.classList.contains("will-remove-item")) {

  const currentItem = event?.target?.closest("[data-cart-item]");
  if (!currentItem) return;

  const bundleUniqueId = currentItem.getAttribute("_unique_custom_id");
  if (!bundleUniqueId) return;

  const excludedId = String(currentItem.getAttribute("data-variant-id"));

  const cart = await fetch("/cart.js").then((r) => r.json());
  if (!cart?.items?.length) return;

  const updates = cart.items.map((item) => item.quantity);

  // Step 1: Set quantity 0 for all items in this bundle
  cart.items.forEach((item, index) => {
    const bundleId = item.properties?._unique_custom_id;
    if (!bundleId) return;
    if (bundleId !== bundleUniqueId) return;

    updates[index] = 0;
  });

  const cartBody = document.querySelector(".cart-body");
  if (cartBody) {
    cartBody.classList.add("loading");
  }

  // Step 2: Remove the entire bundle
  await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates,
      sections: `${cartSectionID},header`,
    }),
  })
    .then((res) => res.json())
    .then(async (dataJSON) => {
      // Step 3: Add back items that are NOT the excluded variant, **with original quantity**
      const itemsToAdd = cart.items
        .filter((item) => {
          const bundleId = item.properties?._unique_custom_id;
          if (!bundleId) return false;
          if (bundleId !== bundleUniqueId) return false;
          return String(item.variant_id) !== excludedId;
        })
        .map((item) => {
          const existingProps = item.properties || {};
          const properties = {};

          ["_processing_time", "Personalization", "additional cost"].forEach(
            (key) => {
              if (existingProps[key]) {
                properties[key] = existingProps[key];
              }
            }
          );

          // ✅ Preserve the original quantity instead of always 1
          return {
            id: item.variant_id,
            quantity: item.quantity,
            properties,
          };
        });

      if (!itemsToAdd.length) return;

      // Step 4: Add back the leftover items with correct quantities
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: itemsToAdd,
          sections: `${cartSectionID},header`,
        }),
      })
        .then((res) => res.json())
        .then((addJSON) => {
           sessionStorage.removeItem("NumberOnBack");
           document.querySelectorAll("[data-personalization-input]").forEach?.(el => el.value = "");
          BundleProduct.getEligibleBundleProductId().then(async (result) => {
            

            if (result) {
              const parentId = await BundleProduct.getCorrectCompleteBundleParent(
                result
              );

              if (parentId) {
                console.log("Final Parent Bundle to process:", parentId);
              }
            } else {
              console.log("No matching product found");
            }
          });

          if (document.querySelector("cart-form")) {
            document.querySelector("cart-form")._updateCart(addJSON.sections);
            if (cartBody) {
              cartBody.classList.remove("loading");
            }
          } else {
            window.location.href =
              window.routes?.cart_fetch_url || "/cart";
          }
        });
    });

  return;
}
else{
 let vId = lineItem.getAttribute("data-variant-id");
 const properties = {};

const processingTime = lineItem.getAttribute("data-processing-time");
const personalization = lineItem.getAttribute("data-personalization");
const additionalCost = lineItem.getAttribute("data-additional-cost");

if (processingTime) {
  properties["_processing_time"] = processingTime;
}

if (personalization && personalization.trim() !== "") {
  properties["Personalization"] = personalization;
}

if (additionalCost && additionalCost !== "0" && additionalCost !== "0.00") {
  properties["additional cost"] = additionalCost;
}

 let formData = {
  items: [
    {
      id: vId,
      quantity: 1,
      properties
    },
  ],
  sections: `${cartSectionID},header`,
};

  fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
        .then((res) => res.json())
        .then((addJSON) => {
           sessionStorage.removeItem("NumberOnBack");
           document.querySelectorAll("[data-personalization-input]").forEach?.(el => el.value = "");
                 BundleProduct.getEligibleBundleProductId().then(async (result) => {

            if (result) {
              const parentId = await BundleProduct.getCorrectCompleteBundleParent(
                result
              );

              if (parentId) {
                console.log("Final Parent Bundle to process:", parentId);
              }
            } else {
              console.log("No matching product found");
            }
          });
          if (document.querySelector("cart-form")) {
            document
              .querySelector("cart-form")
              ._updateCart(addJSON.sections);
          } else {
            window.location.href =
              window.routes?.cart_fetch_url || "/cart";
          }
        });
        return;
}
}


}
  

  const body = JSON.stringify({
    line,
    quantity,
    sections: `${this.sectionID},header`,
  });

  fetch(`${routes.cart_change_url}`, {
    ...Utility.fetchConfig(),
    body,
  })
    .then((response) => response.text())
    .then((_state) => {
      const dataJSON =
        typeof _state === "object" ? _state : JSON.parse(_state);

      if (dataJSON.errors) {
        window.notificationEle.updateNotification(
          "Cart Update",
          dataJSON.errors,
          { type: "error", timeout: 5000 }
        );
        return;
      }

      eventBus.publish(PUB_SUB_EVENTS.cartUpdate, {
        data: {
          action: quantity === 0 ? "remove-item" : "update-qty",
          item:
            quantity === 0
              ? dataJSON.items_removed
              : dataJSON.items_added,
        },
      });

      this._updateCart(dataJSON.sections);
    })
    .catch((error) => {
      window.notificationEle.updateNotification("Cart Update", error, {
        type: "error",
        timeout: 5000,
      });
    })
    .finally(() => {
      setTimeout(() => {
        lineItem.classList.remove("updating");
      }, 300);
    });
}


  /**
   * Bulk Item Quantity update API
   *
   * @param {string} line Line Index value of cart Item (Starts from 1)
   * @param {integer} quantity Quantity to update
   */
  bulkUpdateQuantity(items, quantity, sections, lineItem) {
    if (lineItem) lineItem.classList.add("updating");

    const payload = {
      id: items,
      quantity: 1,

      sections: sections,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((dataJSON) => {
         sessionStorage.removeItem("NumberOnBack");
         document.querySelectorAll("[data-personalization-input]").forEach?.(el => el.value = "");
        this._updateCart(dataJSON.sections);
      })
      .catch((error) => {
        console.error("Error:", error);
        window.notificationEle.updateNotification("Cart Update", error, {
          type: "error",
          timeout: 5000,
        });
      })
      .finally(() => {
        // if (lineItem) lineItem.classList.remove('updating');
      });
  }
  /**
   * Remove Item Event
   */
  removeItem(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const itemIndex = currentTarget.dataset.index || null;
    if (itemIndex !== null) {
      this.updateItemQty(itemIndex, 0, event);
    }
  }

  /**
   * Cart Item Qunatity Increment/Decrement Button event
   */
  manageQtyBtn(event) {
    event.preventDefault();
    const { currentTarget } = event;
    const action = currentTarget.dataset.for || "increase";
    const qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    const itemIndex = qtyInput.dataset.index || 1;

    const stepQty = qtyInput.step ? parseInt(qtyInput.step) : 1;
    const minQty = qtyInput.min ? parseInt(qtyInput.min) : 1;
    const maxQty = qtyInput.max ? parseInt(qtyInput.max) : null;

    const currentQty = parseInt(qtyInput.value, 10) || minQty;
    let finalQty = currentQty;

    if (action === "decrease" && currentQty <= minQty) {
      this.updateItemQty(itemIndex, 0, event);
      return;
      // eslint-disable-next-line no-else-return
    } else if (
      action === "increase" &&
      maxQty != null &&
      currentQty >= maxQty
    ) {
      return false;
    }

    if (action === "decrease") {
      finalQty = currentQty - stepQty;
    } else {
      finalQty = currentQty + stepQty;
    }

    this.updateItemQty(itemIndex, finalQty, event);
  }

  /**
   * Cart Item Qunatity Input change event
   */
  onQtyChange(e) {
    const input = e.target;
    const min = parseInt(input.min || 1, 10);
    const max = input.max ? parseInt(input.max, 10) : null;
    let value = parseInt(input.value, 10) || min;
    if (value < min) {
      value = min;
    } else if (max && value > max) {
      value = max;
    }
    input.value = value;
    const itemIndex = input.dataset.index || 1;
    this.updateItemQty(itemIndex, value, e);
  }
}
customElements.define("cart-form", AjaxCart);
